import { render, staticRenderFns } from "./TransactionPaidMessage.vue?vue&type=template&id=18d55b6f&"
import script from "./TransactionPaidMessage.vue?vue&type=script&lang=ts&"
export * from "./TransactionPaidMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports